import React from "react";
import { Trans } from "adapters/i18n";

export const PesoVisualMedioTooltip = () => {
  return (
    <Trans i18nKey="statusIndicator:average-visual-weight-tooltip"
      components={{
        div: <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            fontFamily: "Roboto",
            padding: "2px",
          }}/>,
          span: <span />,
        strong: <strong />
      }}
    />
  );
};
